import React from 'react'

import Hr from 'components/Common/Hr'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import FlightItemCardContent from 'tripPlanner/components/ItemCard/Flight/FlightItemCardContent'
import RestoreCartModalFooter from 'tripPlanner/components/TripModal/TripItems/Common/RestoreCartModalFooter'
import SummaryAdditionalNotes from 'tripPlanner/components/TripModal/TripItems/Summary/Common/SummaryAdditionalNotes'
import FlightSummaryModalFooter from 'tripPlanner/components/TripModal/TripItems/Summary/Common/SummaryModalFooter/FlightSummaryModalFooter'
import ReadOnlyItemFooter from 'tripPlanner/components/TripModal/TripItems/Summary/Common/SummaryModalFooter/ReadOnlyItemFooter'
import { FlightBookingInfo } from 'tripPlanner/components/TripModal/TripItems/Summary/FlightBookingInfo'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import type { FlightItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'
import { isBookableItem } from 'tripPlanner/utils/bookmark/restoreCart'

interface Props {
  item: FlightItem
}

function FlightItemSummary(props: Props) {
  const { item } = props

  const { closeModal, goBack } = useModalCallbacks()

  const canEdit = useCanEditTrip()
  const isBookable = isLeBookmark(item) && isBookableItem(item)

  const hasConfirmationItemCodes =
    item.confirmationCode && item.confirmationItemCodes.length > 0

  return (
    <>
      <ModalHeader
        title={`${item.startPlace.name || item.originAirportCode} to ${
          item.endPlace.name || item.destinationAirportCode
        }`}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalContent>
          <FlightItemCardContent item={item} variant="tripSummary" />
          {(hasConfirmationItemCodes || item.notes) && <Hr size="md" />}
          {hasConfirmationItemCodes && <FlightBookingInfo item={item} />}
          <SummaryAdditionalNotes notes={item.notes} />
        </ModalContent>
      </ModalBody>

      {canEdit && (
        <>
          {isBookable && <RestoreCartModalFooter item={item} />}
          {!isBookable && <FlightSummaryModalFooter item={item} />}
        </>
      )}
      {!canEdit && <ReadOnlyItemFooter item={item} />}
    </>
  )
}

export default FlightItemSummary
